import { useContext, useState, useEffect } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import GlobalContext from '../../../contexts/index';
import useFetchData from '../../../hooks/useFetchData';
import useSort from '../../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import globalTranslating from '../../../translate.json';
import GeneParamsTranslating from '../translate.json';
import SnackBar from 'components/SnackBar';

const GeneTestForm = () => {
  const translating = { ...globalTranslating, ...GeneParamsTranslating };
  const { data: subCategoriesData } = useFetchData('report-text/SubCategoris');
  const { data: categoriesData } = useFetchData('report-text/Categoris');
  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const [filteredGeneParams, setFilteredGeneParams] = useState([]);
  const { data: GeneParamsData, loading } = useFetchData('gene-analyze');
  const [searchParams] = useSearchParams();
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  useEffect(() => {
    if (GeneParamsData?.length) setFilteredGeneParams(GeneParamsData);
  }, [GeneParamsData]);

  const onFilter = (filteredData) => {
    setFilteredGeneParams(filteredData);
  };

  const onResetFilters = () => {
    setFilteredGeneParams(GeneParamsData);
  };

  const { showFilters, toggle } = useSort();

  const tableHeaders = [
    translating.name,
    'rsNo',
    translating.gender,
    translating.genotip,
    translating.weight,
    translating.category,
    translating.txtNo
  ];

  const columns = [
    { value: 'Gene', bold: true },
    { value: 'rsNo' },
    { value: 'eGenderLab' },
    { value: 'genotip' },
    { value: 'geneWeight' },
    { value: 'geneSubCategory', subField: 'name' },
    { value: 'reportTextId' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['Gene', 'rsNo', 'genotip', 'geneWeight', 'reportTextId']
    },
    {
      type: 'multiselect',
      label: translating.subCategory,
      placeholder: translating.type3Dots,
      name: 'geneSubCategoryId',
      options: subCategoriesData
    },
    {
      type: 'multiselect',
      label: translating.category,
      placeholder: translating.type3Dots,
      name: 'geneSubCategory',
      subField: 'categoryId',
      options: categoriesData
    }
  ];

  const actionsUsersList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredGeneParams(GeneParamsData);
        toggle(!showFilters);
      }
    }
  ];

  return (
    <div className="Gene-params-list">
      <ListHeader
        title={translating.GeneParamsListTitle}
        newItem={{ handleClick: () => setLink('d2') }}
        actions={actionsUsersList}
      ></ListHeader>
      {showFilters && subCategoriesData && categoriesData && (
        <Filter
          fields={sortFields}
          data={GeneParamsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="Gene-params-wrapper-table">
        {loading && <div>Loading</div>}
        {GeneParamsData && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredGeneParams}
            pagination={true}
            handleRowClick={(id) => {
              navigate(`/labs/gene/${id}`);
            }}
          ></TablePagination>
        )}
      </div>
      {showSnackbar && (
        <SnackBar
          msg={'מדד נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default GeneTestForm;
